import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragAreaIcon from '../../assets/icons/DragAreaIcon.svg?react';
import ProviderName from './ProviderName';
import { providerRowHeaderClasses } from '../common/formClasses';

const wrapperBaseClasses =
    'rounded-lg bg-surface-alt p-4 mb-4 transition-transform duration-200 ease-[ease]';
const wrapperDraggingClasses = 'transition-none opacity-60';
const rowClasses = 'flex gap-6';
const handleClasses = 'flex items-center bg-border p-2 self-start';
const bodyClasses = 'w-full';

const SortProvider = ({ id, providerIndex, children, providerType }) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useSortable({ id });
    return (
        <div
            ref={setNodeRef}
            style={{ transform: CSS.Transform.toString(transform) }}
            {...attributes}
            {...listeners}
            className={`${wrapperBaseClasses} ${isDragging ? wrapperDraggingClasses : ''}`}
        >
            <div className={rowClasses}>
                <span className={handleClasses}>
                    <DragAreaIcon />
                </span>
                <div className={bodyClasses}>
                    <div className={providerRowHeaderClasses}>
                        <div className="flex items-center gap-2 w-full!">
                            <ProviderName providerIndex={providerIndex} providerType={providerType} />
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};

SortProvider.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    providerIndex: PropTypes.number.isRequired,
    children: PropTypes.node,
    providerType: PropTypes.string.isRequired,
};

export default SortProvider;
